import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export type PositionsDrawerOpenOrdersTab = "all" | "options" | "perps";

export const positionsDrawerOpenOrdersTabAtom =
  atomWithStorage<PositionsDrawerOpenOrdersTab>(
    "positionsDrawerOpenOrdersTab",
    "all",
  );

export const usePositionsDrawerOpenOrdersTab = () => {
  const [positionsDrawerOpenOrdersTab, setPositionsDrawerOpenOrdersTab] =
    useAtom(positionsDrawerOpenOrdersTabAtom);

  return {
    positionsDrawerOpenOrdersTab,
    setPositionsDrawerOpenOrdersTab,
  };
};
